// extracted by mini-css-extract-plugin
module.exports = {"EditDocumentation__button-group__3sq5-":"EditDocumentation__button-group__3sq5-"};